export const kTopbarHeight = '72px'

// SIDEBAR DIMENSIONS
export const kExpandedSidebarWidth = '280px'
export const kSidebarShrinkWidth = '65px'

export const kSidebarTopPosition = kTopbarHeight
export const kSidebarHeight = `calc(100vh - ${kTopbarHeight})`
